module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-1-26024320fa750c56aa1d0db464b490f4.jpg";